module.exports = __webpack_public_path__ + "img/news1.865bbc03.jpg";